import Languages from '../../../../utils/Languages.js'
import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {addressLines, card, field, intro, mailDocument, multiline, stack} from './mailLayout.js'

const template = ({
    logo,
    color = '#ff751a',
    message,
    addressHeader = Languages.deliveryAddress.NL,
    senderHeader = Languages.consignor.NL,
    referenceHeader = Languages.reference.NL,
    barcodeHeader = Languages.mailTrackTrace.NL,
    parcel
}, baseUrl?: string) => {
    const senderAddress = parcel?.senderAddress || {}

    return mailDocument({
        logo,
        color,
        baseUrl,
        content: stack([
            intro(multiline(message)),
            card([
                field(addressHeader, addressLines(parcel?.address)),
                field(senderHeader, senderAddress.name || ''),
                parcel?.reference && field(referenceHeader, parcel.reference),
                field(barcodeHeader, parcel?.trackTrace || '')
            ])
        ])
    })
}

export default escapedTemplate(template)
